"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _utils = require("../../utils");
/**
 * Clears meeting session state
 */
function clearMeeting() {
  return (0, _utils.actionCreator)(_types.BROADCAST_CLEAR_MEETING);
}
var _default = exports["default"] = clearMeeting;